/**
 * Homepage “speaks your tools” chip wall. Agents first, then developer
 * services. Each `icon` is a file in `public/images/icons/{icon}.svg`.
 * Marks come from the same official paths used on onboarding / connect —
 * do not invent lookalikes.
 */
export const landingWorldBrands = [
	{ label: 'Cursor', icon: 'cursor' },
	{ label: 'Claude Code', icon: 'claudecode' },
	{ label: 'ChatGPT', icon: 'chatgpt' },
	{ label: 'Codex', icon: 'codex' },
	{ label: 'Warp', icon: 'warp' },
	{ label: 'Amp', icon: 'amp' },
	{ label: 'Gemini', icon: 'gemini' },
	{ label: 'OpenClaw', icon: 'openclaw' },
	{ label: 'GitHub', icon: 'github' },
	{ label: 'Linear', icon: 'linear' },
	{ label: 'Sentry', icon: 'sentry' },
	{ label: 'Cloudflare', icon: 'cloudflare' },
	{ label: 'Slack', icon: 'slack' },
] as const
